import ecoImage from './assets/eco-image.webp';
export const mapContent = {
  title: [
    { text: 'район, где город', accent: true },
    { text: 'встречается', accent: false },
    { text: 'с курортом', accent: false },
  ],

  tabs: [
    { id: 'ecology', label: 'экология', color: '#25A864' },
    { id: 'transport', label: 'транспорт', color: '#4B69F1' },
    { id: 'dosug', label: 'досуг', color: '#FF8F57' },
  ],

  info: {
    ecology: {
      title: [
        { text: 'ЭКОЛОГИЯ', accent: true },
        { text: 'и «зеленые легкие»', accent: false },
      ],
      image: ecoImage,
      body: [
        {
          segments: [
            { text: 'комплекс дышит Закамским бором,', accent: true },
            { text: ' который наполняет воздух хвойным ароматом и фитонцидами', accent: false },
          ],
        },
      ],
    },
    transport: {
      title: [
        { text: 'транспортная', accent: false },
        { text: 'мобильность', accent: true },
      ],
      body: [
        {
          segments: [
            { text: '8 минут — время\n', accent: true, break: true },
            { text: ' в пути до центра Перми', accent: false },
          ],
        },
        {
          segments: [
            { text: 'несмотря на уединение, вы остаетесь мобильными.', accent: true },
            {
              text: ' до делового центра города и ключевых ТЦ (IMall, Колизей, СпешиLove) всего 8 минут на автомобиле',
              accent: false,
            },
          ],
        },
      ],
    },
    dosug: {
      title: [
        { text: 'развлечения', accent: true },
        { text: 'и отдых в 5 минутах', accent: false },
      ],
      body: [
        {
          segments: [
            { text: 'район трансформируется', accent: true, break: true },
            { text: ' в главный рекреационный хаб региона', accent: false },
          ],
        },
        {
          segments: [
            { text: 'совсем скоро рядом откроется термальный комплекс Baden-Baden.', accent: true },
            { text: ' а городской пляж и бульвар уже доступны жителям', accent: false },
          ],
        },
      ],
    },
  },

  markers: [
    {
      id: 'logo',
      category: 'logo',
      title: 'ЖК Причал',
      x: 1077,
      y: 202,
      xTablet: 1007,
      yTablet: 192,
      xMobile: 1017,
      yMobile: 202,
      labelSide: 'down',
      labelAlwaysVisible: true,
    },

    {
      id: 'eco-1',
      category: 'ecology',
      title: 'место отдыха Большое Сосновое',
      x: 1041,
      y: 47,
      xTablet: 1041,
      yTablet: 47,
      xMobile: 981,
      yMobile: 47,
      labelSide: 'left',
    },
    { id: 'eco-2', category: 'ecology', title: 'Лыжероллерная трасса', x: 698, y: 494, xTablet: 398, yTablet: 174, xMobile: 398, yMobile: 174 },
    { id: 'eco-3', category: 'ecology', title: 'Экотропа Большая Сосновая', x: 909, y: 197, xTablet: 839, yTablet: 197, xMobile: 839, yMobile: 187 },
    { id: 'eco-4', category: 'ecology', title: 'Экотропа лесоводов Прикамья', x: 767, y: 289, xTablet: 707, yTablet: 289, xMobile: 683, yMobile: 289 },
    { id: 'eco-5', category: 'ecology', title: 'Закамский бор', x: 753, y: 356, xTablet: 653, yTablet: 356, xMobile: 663, yMobile: 376 },

    { id: 'dosug-1', category: 'dosug', title: 'ТЦ Спешилов', x: 362, y: 334, xTablet: 242, yTablet: 334, xMobile: 242, yMobile: 334 },
    { id: 'dosug-2', category: 'dosug', title: 'Картинг «Камская долина»', x: 503, y: 410, xTablet: 383, yTablet: 410, xMobile: 383, yMobile: 410 },
    { id: 'dosug-3', category: 'dosug', title: 'Городской пляж', x: 613, y: 536, xTablet: 513, yTablet: 516, xMobile: 513, yMobile: 536 },
    {
      id: 'dosug-4',
      category: 'dosug',
      title: 'Пермская художественная галерея',
      x: 834,
      y: 631,
      xTablet: 754,
      yTablet: 631,
      xMobile: 754,
      yMobile: 631,
      labelSide: 'left',
    },
    { id: 'dosug-5', category: 'dosug', title: 'Набережная', x: 623, y: 672, xTablet: 533, yTablet: 672, xMobile: 533, yMobile: 672 },
    { id: 'dosug-6', category: 'dosug', title: 'Театр оперы и балета', x: 772, y: 688, xTablet: 682, yTablet: 672, xMobile: 682, yMobile: 672 },
    { id: 'dosug-7', category: 'dosug', title: 'ТЦ Imall', x: 629, y: 735, xTablet: 539, yTablet: 735, xMobile: 539, yMobile: 735 },
    {
      id: 'dosug-8',
      category: 'dosug',
      title: 'Городская эспланада',
      x: 582,
      y: 773,
      xTablet: 472,
      yTablet: 773,
      xMobile: 472,
      yMobile: 763,
      labelSide: 'left',
    },
    { id: 'dosug-9', category: 'dosug', title: 'Театр-театр', x: 512, y: 815, xTablet: 422, yTablet: 825, xMobile: 422, yMobile: 815, labelSide: 'left' },
    { id: 'dosug-10', category: 'dosug', title: 'ТЦ Колизей', x: 690, y: 799, xTablet: 590, yTablet: 809, xMobile: 590, yMobile: 799 },
    { id: 'dosug-11', category: 'dosug', title: 'ТЮЗ', x: 777, y: 755, xTablet: 707, yTablet: 755, xMobile: 707, yMobile: 755 },
  ],
};
